const CLASS_PUT_UP_HEIGHT: string = 'put-up-height';

function main( collection: NodeListOf<HTMLElement> ): void
{
	if ( collection[0].parentElement.classList.contains( CLASS_PUT_UP_HEIGHT ) )
	{
		collection[0].parentElement.classList.remove( CLASS_PUT_UP_HEIGHT );
	}
	
	let maxHeight: number = 0;

	collection[0].parentElement.style.height = '';

	for( let i=0 ; i < collection.length; i++ )
	{
		if ( maxHeight < collection[i].offsetHeight )
		{
			maxHeight = collection[i].offsetHeight;

			collection[i].parentElement.style.height = maxHeight + 'px';
		}
	}
	
	collection[0].parentElement.classList.add( CLASS_PUT_UP_HEIGHT );
}

export {
	main as default,
}